import React from 'react';

import type { ButtonProps } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { LookoButtonInternal, LookoButtonInternalProps, lookoButtonHeight } from './LookoButtonInternal';

export interface LookoButtonBaseProps extends LookoButtonInternalProps {
  /**
   * 형태
   * @default 'contained'
   */
  variant?: 'contained' | 'outlined' | 'text';

  /**
   * 색상
   * @default 'primary'
   */
  color?: 'primary' | 'error' | 'inherit';

  /**
   * 로딩 아이콘 표시 여부.
   */
  loading?: boolean;
}

/**
 * Looko 버튼 Base.
 */
export const LookoButtonBase = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & LookoButtonInternalProps & Pick<LookoButtonBaseProps, 'loading'>
>(({ loading, ...props }, ref) => (
  <LookoButtonInternal
    ref={ref}
    startIcon={
      loading ? <CircularProgress color={undefined} size={lookoButtonHeight[props.size ?? 'medium'] / 2} /> : undefined
    }
    {...props}
    disabled={loading || props.disabled}
  />
));
